// extracted by mini-css-extract-plugin
export default {"loaderSection":"loaderWhite_loaderSection__4xo02","loaderSecitionh1":"loaderWhite_loaderSecitionh1__Rbc8U","lds_ring":"loaderWhite_lds_ring__OlWU6"};